import React, { useCallback, useEffect, useState } from "react";

import { getAllMarketplaceSupplierPricesForSku } from "../../../../services/sku";
import Modal from "../Modal";

const AverageSellingPriceModal = (props) => {
  const { close, skuId } = props;

  const [suppliersPrices, setSuppliersPrices] = useState([]);

  const fetchMarketplaceSupplierPrices = useCallback(async () => {
    try {
      const response = await getAllMarketplaceSupplierPricesForSku(skuId);

      const {
        data: { data },
      } = response;

      setSuppliersPrices(data);
    } catch (err) {
      console.error(err);
    }
  }, [skuId]);

  useEffect(() => {
    fetchMarketplaceSupplierPrices();
  }, [fetchMarketplaceSupplierPrices]);

  return (
    <Modal close={props.close}>
      <h3 className="text-center mb-6">أسعار الموردين</h3>

      {suppliersPrices.length > 0 ? (
        <table className="w-full text-center border text-sm ">
          <thead>
            <tr>
              <th className="bg-slate-100">اسم المورد</th>
              <th className="bg-slate-100">منطقة المورد</th>
              <th className="bg-slate-100">سعر المورد</th>
            </tr>
          </thead>
          <tbody>
            {suppliersPrices.map((supplier, index) => (
              <tr key={index}>
                <td className="p-2">{supplier.supplierName}</td>
                <td className="p-2">{supplier.supplierArea}</td>
                <td className="p-2">{supplier.price.toFixed(2)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p>لا يوجد أسعار</p>
      )}

      <div className="flex justify-between mt-6">
        <button
          className="p-2 bg-light-gray font-bold text-sm rounded"
          onClick={close}
        >
          إلغاء
        </button>
      </div>
    </Modal>
  );
};

export default AverageSellingPriceModal;
